import { Component, forwardRef, input, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { GenericDropdownComponent, IGenericTypeAheadDropdownConfig } from 'ngx-lib';

@Component({
    selector: 'app-reactive-dropdown',
    templateUrl: './reactive-dropdown.component.html',
    styleUrls: ['./reactive-dropdown.component.scss'],
    imports: [GenericDropdownComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ReactiveDropdownComponent),
            multi: true
        }
    ]
})
export class ReactiveDropdownComponent<T> implements ControlValueAccessor {
    label = input<string>();
    source = input<T[]>([]);
    config = input<IGenericTypeAheadDropdownConfig<T>>();
    placeholder = input<string>();
    disabled = input<boolean>(false);
    isReadOnly = input<boolean>(false);
    noResultsText = input<string>('No matches found');
    error = input<boolean>(false);

    selectedItem: T | undefined = undefined;
    isDisabled = false;

    writeValue(value: T | undefined): void {
        this.selectedItem = value;
    }

    registerOnChange(fn: (value: T | undefined) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    get isComponentDisabled(): boolean {
        return this.disabled() || this.isDisabled;
    }

    onSelectionChange(item: T | undefined): void {
        this.selectedItem = item;
        this.onChange(item);
        this.onTouched();
    }

    private onChange: (value: T | undefined) => void = () => {
        // registerOnChange()
    };

    private onTouched: () => void = () => {
        // registerOnTouched()
    };
}
